/* eslint-disable prefer-regex-literals */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
// import ApiAuth from '../servicios/ApiAuth'
import store from '../almacen'
import { Actions } from '../almacen/enums/StoreEnums'
import CookieService, { SEGURPASS } from '../servicios/CookieService'
import MessageService, { MessageType } from '../servicios/MessageService'
// import HelperSecurity from './HelperSecurity'
import html2canvas from 'html2canvas'
import { Router } from 'vue-router'
import { TYPES } from '../../domain/types'
import { IServiceAuth } from '../../../entidades/builderMaster/auth/application/IServiceAuth'
import { Container } from 'inversify'


const salir = (container: Container, router: Router): void => {
  //  HelperSecurity.logout(sessionId)
  MessageService.showMessage(MessageType.Info, 'Cerrando entorno', 'Por favor espere...', false)
  const _srvAuth = container.get<IServiceAuth>(TYPES.AUTH_SERVICE)
  _srvAuth.logout().finally(() => {
    store.dispatch(Actions.LOGOUT).then(() => {
      CookieService.destroy(SEGURPASS)
      MessageService.hideAllMessages()
      if (router) {
        router.push({ name: 'login' })
      }
    })

  })
}

const getWhoAmIProfiles = async (container: Container, router: Router): Promise<any> => {
  return await new Promise<void>((resolve, reject) => {
    const _srvAuth = container.get<IServiceAuth>(TYPES.AUTH_SERVICE)
    _srvAuth.whoAmIProfiles()
      .then((response: any) => {
        //this.context.commit(Mutations.SET_WHOAMIPROFILES, [this, response])
        resolve(response)
      })
      .catch((e) => {
        reject()
      })
  })
}

const formateaFechaHoraLarga = (value: string | number | Date) => {
  if (!value) {
    return null
  }
  const date = new Date(value)
  return date.toLocaleString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })
}
function padLeft(num: number, dig: number) {
  return ''// num.toString().padStart(dig, '0')
}
const formateaFechaHora = (value: string | number | Date) => {
  if (!value) {
    return null
  }
  const date = new Date(value)

  return ("00" + (date.getMonth() + 1)).slice(-2) + "/" +
    ("00" + date.getDate()).slice(-2) + "/" +
    date.getFullYear() + " " +
    ("00" + date.getHours()).slice(-2) + ":" +
    ("00" + date.getMinutes()).slice(-2) + ":" +
    ("00" + date.getSeconds()).slice(-2);
}
const formateaFecha = (value: string | number | Date) => {
  if (!value) {
    return null
  }
  const date = new Date(value)
  return date.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
}

const diferenciaFechasEnDias = (fecha1: number, fecha2: number) => {
  const diffInMs = Math.abs(fecha2 - fecha1)
  return Math.ceil(diffInMs / (1000 * 60 * 60 * 24))
}

const obtenerTextoMensajes = (response: { messages: never[] }) => {
  const msgs = response.messages ?? []
  const msgStr = msgs.map((value: { description: any }) => value.description).join(',')
  return msgStr
}

const TestServiceMail = async (sessionId: string): Promise<boolean> => {
  return await new Promise<boolean>((resolve, reject) => {
    /* ApiAuth.post('/test/testServiceMail?sessionID=' + sessionId, {})
      .then((response) => {
        resolve(response.data)
      })
      .catch(() => {
        reject()
      }) */
  })
}

const getDomUploader = (dv: { currentTarget: any }, options: string | any[] | null) => {
  const root = dv.currentTarget ?? dv
  Array.prototype.forEach.call(root.getElementsByClassName('p-fileupload-filename'), function (element) {
    if (element.previousSibling.innerHTML.indexOf('<option') === -1) {
      const div = document.createElement('div')

      const input = document.createElement('input')
      input.className = 'p-inputtext p-component'
      input.id = 'description_' + element.innerText
      input.placeholder = 'Descripción'
      input.title = 'Descripción'
      div.append(input)
      insertAfter(div, element.previousSibling)

      if (options != null) {
        const selectList = document.createElement('select')
        selectList.id = 'type_' + element.innerText
        selectList.className = 'p-dropdown p-inputtext p-placeholder'
        selectList.title = 'Tipo de documento'
        selectList.setAttribute('pepe', '')

        for (let i = 0; i < options.length; i++) {
          const option = document.createElement('option')
          option.value = options[i].id
          option.text = options[i].description
          selectList.appendChild(option)
        }

        insertAfter(selectList, element.previousSibling)
      }
    }
  })
}

const insertAfter = (newElement: HTMLDivElement | HTMLSelectElement, referenceElement: { parentNode: { insertBefore: (arg0: any, arg1: any) => void }, nextSibling: any }) => {
  referenceElement.parentNode.insertBefore(newElement, referenceElement.nextSibling)
}

const toBase64 = async (file: Blob) =>
  await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = (error) => { reject(error) }
  })

const toText = async (file: Blob) =>
  await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsText(file)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = (error) => { reject(error) }
  })

const toArrayBuffer = async (file: Blob) =>
  await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = (error) => { reject(error) }
  })

const formateaMoneda = (valor: number | bigint) => {
  if (!valor) {
    return null
  }
  const formatter = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' })
  //return formatter
  return formatter.format(valor)
}


const formateaPorcentaje = (valor: number | bigint) => {
  if (!valor) {
    return null
  }

  return parseFloat(valor?.toString()).toFixed(2) + " %";
}

const navegarAlDocumento = (url: string) => {
  window.open(url, '_blank')
}

const validarEmail = (email: string | null) => {
  if (typeof email === 'undefined' || email === null || email === '') {
    return true
  }
  return /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*;{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,10})[\W]*$/.test(email)
}
function texoEstaVacio(texto: { match: (arg0: RegExp) => null } | null) {
  return texto === null || texto.match(/^ *$/) !== null
}
function onlyUnique(value: any, index: any, self: string | any[]) {
  return self.indexOf(value) === index
}
function cambiarLuminosidadColor(hex: string | any[], lum: number) {
  // esta funcion devuelve un código de color un % mas oscuro o claro del color indicado.
  // hex: el código hexadecimal del color (ej: #123456)
  // lum: el factor de luminosidad, es decir, -0,1 es un 10 % más oscuro, 0,2 es un 20 % más claro, etc.
  lum = lum || 0
  hex = String(hex).replace(/[^0-9a-f]/gi, '')
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
  }
  let rgb = '#'
  let c
  let i
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16)
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16)
    rgb += ('00' + c).substr(c.length)
  }

  return rgb
}

const validarIban = (iban: string | any[] | any | null) => {
  if (typeof iban === 'undefined' || iban === null || iban === '') {
    return false
  }

  if (iban.length < 20) {
    return false
  }

  return /^ES\d{22}$/.test(iban)
}

const toNumber = (valor: string | null) => {
  if (typeof valor === 'undefined' || valor === null || valor === '') {
    return 0
  }

  return Number(valor.replace('.', '').replace(',', '.'))
}

const getCurrentDateTimeLongFormat = () => {
  return new Date().toLocaleDateString('es-ES', {
    weekday: 'long',
    hour12: false,
    hour: 'numeric',
    minute: 'numeric'
  })
}

const stringToBoolean = (stringValue: string) => {
  switch (stringValue?.toLowerCase()?.trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true

    case 'false':
    case 'no':
    case '0':
    case '':
    case null:
    case undefined:
      return false

    default:
      return JSON.parse(stringValue)
  }
}

const setFocusOnFirstError = () => {
  setTimeout(() => {
    for (let i = 0; i < document.getElementsByClassName('p-invalid').length - 1; i++) {
      const ctrl = document.getElementsByClassName('p-invalid')[i] as any
      ctrl.focus()
      ctrl.scrollIntoView()
    }
  }
    , 100)
}

const isNullOrWhitespace = (input: string) => {
  try {
    return !input || !input.trim()
  } catch {
    return false
  }
}

const prettifyXml = (sourceXml: string) => {
  try {
    const xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml')
    const xsltDoc = new DOMParser().parseFromString([
      // describes how we want to modify the XML - indent everything
      '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
      '  <xsl:strip-space elements="*"/>',
      '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
      '    <xsl:value-of select="normalize-space(.)"/>',
      '  </xsl:template>',
      '  <xsl:template match="node()|@*">',
      '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
      '  </xsl:template>',
      '  <xsl:output indent="yes"/>',
      '</xsl:stylesheet>'
    ].join('\n'), 'application/xml')

    const xsltProcessor = new XSLTProcessor()
    xsltProcessor.importStylesheet(xsltDoc)
    const resultDoc = xsltProcessor.transformToDocument(xmlDoc)
    const resultXml = new XMLSerializer().serializeToString(resultDoc)
    return resultXml
  } catch (ex) {
    return sourceXml
  }
}

const getExtensionFile = (fileName: string) => {
  if (fileName) {
    const regex = new RegExp('[^.]+$')
    return fileName.match(regex)
  }

  return ''
}

const getCanvas = async (elementId: string): Promise<any> => {
  return await new Promise<any>((resolve, reject) => {
    const el = document.getElementById(elementId)

    if (el != null) {
      const options = {
        // type: 'dataURL',
        logging: true,
        backgroundColor: 'white',
        foreignObjectRendering: false,
        removeContainer: true,
        allowTaint: true,
        useCORS: true
      } as any
      html2canvas(el, options).then(data => {
        resolve(data)
      })
        .catch(() => {
          reject()
        })
    } else {
      resolve(null)
    }
  })
}

const getBase64FromUrl = async (url: string) => {
  const img = new Image()
  img.setAttribute('crossOrigin', 'anonymous')

  return await new Promise((resolve) => {
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      if (ctx != null) {
        ctx.drawImage(img, 0, 0)
        const dataURL = canvas.toDataURL('image/png')
        resolve(dataURL)
      } else {
        resolve('')
      }
    }
    img.src = url
  })
}

const copyToClipBoard = (value: string) => {
  navigator.clipboard.writeText(value);
  MessageService.showToast(MessageType.Correcto, '', 'Se han copiado "' + value + '" al portapapeles.');
}


export default {
  salir,
  getWhoAmIProfiles,
  formateaFecha,
  formateaFechaHoraLarga,
  diferenciaFechasEnDias,
  obtenerTextoMensajes,
  TestServiceMail,
  getDomUploader,
  toBase64,
  toText,
  toArrayBuffer,
  formateaMoneda,
  formateaPorcentaje,
  navegarAlDocumento,
  validarEmail,
  texoEstaVacio,
  onlyUnique,
  cambiarLuminosidadColor,
  formateaFechaHora,
  padLeft,
  validarIban,
  toNumber,
  getCurrentDateTimeLongFormat,
  stringToBoolean,
  setFocusOnFirstError,
  isNullOrWhitespace,
  prettifyXml,
  getExtensionFile,
  getCanvas,
  getBase64FromUrl,
  copyToClipBoard

}
